(function (global) {
  'use strict';

  function normalizeValues(value) {
    var values = Array.isArray(value) ? value : [value];
    return values
      .filter(function (item) {
        return typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean';
      })
      .map(function (item) {
        return String(item).trim();
      })
      .filter(Boolean);
  }

  function addFilters(target, source) {
    if (!source || typeof source !== 'object' || Array.isArray(source)) return;

    Object.keys(source).forEach(function (paramName) {
      if (paramName.indexOf('filter.') !== 0) return;

      var incoming = normalizeValues(source[paramName]);
      if (!incoming.length) return;

      target[paramName] = target[paramName] || [];
      incoming.forEach(function (value) {
        if (target[paramName].indexOf(value) === -1) {
          target[paramName].push(value);
        }
      });
    });
  }

  function collectFilters(history, finalOption) {
    var filters = {};
    (history || []).forEach(function (selection) {
      addFilters(filters, selection && selection.filters);
    });
    addFilters(filters, finalOption && finalOption.filters);

    return filters;
  }

  function appendExistingValues(filters, params) {
    Object.keys(filters).forEach(function (paramName) {
      params.getAll(paramName).forEach(function (existingValue) {
        var value = String(existingValue).trim();
        if (value && filters[paramName].indexOf(value) === -1) {
          filters[paramName].unshift(value);
        }
      });
    });
  }

  function resultMetadata(history, finalOption) {
    if (finalOption && finalOption.result && typeof finalOption.result === 'object') {
      return finalOption.result;
    }
    for (var index = (history || []).length - 1; index >= 0; index -= 1) {
      var selection = history[index];
      if (selection && selection.result && typeof selection.result === 'object') {
        return selection.result;
      }
    }

    return finalOption || {};
  }

  function safeCollectionReturnPath(value, origin) {
    if (typeof value !== 'string' || !value.trim()) return '';

    var baseOrigin = origin || (global.location && global.location.origin) || 'https://example.invalid';
    try {
      var originUrl = new URL(baseOrigin);
      var returnUrl = new URL(value.trim(), originUrl);
      if (returnUrl.origin !== originUrl.origin) return '';
      if (!/^\/collections\/[^/?#]+\/?$/.test(returnUrl.pathname)) return '';

      return returnUrl.pathname.replace(/\/$/, '');
    } catch (error) {
      return '';
    }
  }

  function buildResultUrl(destination, history, finalOption, origin) {
    var baseOrigin = origin || (global.location && global.location.origin) || 'https://example.invalid';
    var url = new URL(destination || '/', baseOrigin);
    var filters = collectFilters(history, finalOption);

    appendExistingValues(filters, url.searchParams);
    Object.keys(filters).forEach(function (paramName) {
      // Un parámetro por valor evita confundir la coma que forma parte de
      // etiquetas reales como "M, Estándar" con el separador OR de Shopify.
      url.searchParams.delete(paramName);
      filters[paramName].forEach(function (value) {
        url.searchParams.append(paramName, value);
      });
    });

    var path = (history || [])
      .map(function (selection) { return selection && selection.label; })
      .filter(Boolean);
    if (finalOption && finalOption.label) {
      path.push(finalOption.label);
    }
    var recommendation = resultMetadata(history, finalOption);

    url.searchParams.set('finalquiz', 'true');
    url.searchParams.set('q', recommendation.label || '');
    url.searchParams.set('p', path.join(' › '));
    if (recommendation.description) {
      url.searchParams.set('d', recommendation.description);
    } else {
      url.searchParams.delete('d');
    }
    if (recommendation.icon) {
      url.searchParams.set('i', recommendation.icon);
    } else {
      url.searchParams.delete('i');
    }

    var originUrl = new URL(baseOrigin);
    return url.origin === originUrl.origin
      ? url.pathname + url.search + url.hash
      : url.toString();
  }

  function mergeFeaturedProducts(featured, grid, documentRef) {
    if (
      !featured
      || !grid
      || !documentRef
      || typeof featured.querySelectorAll !== 'function'
      || typeof documentRef.createDocumentFragment !== 'function'
      || typeof documentRef.createElement !== 'function'
    ) {
      return 0;
    }

    var cards = Array.prototype.slice.call(
      featured.querySelectorAll('.cmx-coll-main__featured-card')
    );
    var fragment = documentRef.createDocumentFragment();

    cards.forEach(function (card) {
      var item = documentRef.createElement('li');
      var child;
      item.className = 'cmx-coll-main__product cmx-coll-main__product--quiz-featured';
      while ((child = card.firstChild)) {
        item.appendChild(child);
      }
      fragment.appendChild(item);
    });

    if (cards.length) {
      grid.insertBefore(fragment, grid.firstChild);
    }
    featured.style.display = 'none';

    return cards.length;
  }

  global.CmxQuizFilters = {
    buildResultUrl: buildResultUrl,
    collectFilters: collectFilters,
    resultMetadata: resultMetadata,
    safeCollectionReturnPath: safeCollectionReturnPath,
    mergeFeaturedProducts: mergeFeaturedProducts
  };
})(typeof window !== 'undefined' ? window : globalThis);
